/* @flow */
import * as React from 'react';

const art = ` __________________________________________________
|.===============================================,|
||  I WILL HANDLE APPLICATION ERRORS GRACEFULLY. ||
||  I WILL HANDLE APPLICATION ERRORS GRACEFULLY. ||
||  I WILL HANDLE APPLICATION ERRORS GRACEFULLY. ||
||  I .----.ANDLE                                ||
||   / ><   \\  /                                 ||
||  |        |/\\                                 ||
||   \\______//\\/                                 ||
||   _(____)/ /                                  ||
||__/ ,_ _  _/___________________________________||
'===\\___\\_) |====================================='
     |______|
     |  ||  |
     |__||__|
     (__)(__)
`;

function Error() {
  return (
    <div
      style={{
        padding: '15px',
        display: 'flex',
        'flex-direction': 'column',
        'align-items': 'center',
      }}>
      <div>
        <pre>
          <code>{art}</code>
        </pre>
      </div>
      <div style={{ marginTop: '35px', 'text-align': 'center' }}>
        <h1 style={{ fontSize: '35px' }}>There’s been an error.</h1>
        <span>
          Please try reloading your browser or clearing your cookies. If you‘re still having
          trouble, contact
          <a href="https://help.remind.com/hc/en-us">Remind Support</a>.
        </span>
      </div>
    </div>
  );
}

export default Error;
